import Layout from "./Layout";
import React, { useMemo, useRef, useState, useEffect } from "react";

import { Link, useNavigate, useLocation } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import jwt_decode from "jwt-decode";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { toast } from "react-toastify";
import ThemeContext from "../context/ThemeContext";
import { t } from "i18next";
import { isEmpty } from "lodash";
import { Form } from "react-bootstrap";
import CanvasCaptcha from "../component/Captcha";
import { isMobile } from "react-device-detect";
import PhoneInput from "react-phone-input-2";
import IndiaIcon from "./IndiaIcon";
const Register = () => {
  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const [checked, setChecked] = useState(false);
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const [step, setStep] = useState(1);
  const theme = useContextSelector(ThemeContext, (ctx) => {
    return ctx.theme;
  });
  const setUser = useContextSelector(AuthContext, (ctx) => {
    return ctx.setUser;
  });
  const [captcha, setCaptcha] = useState("");
  const [showPassword, setShowPassword] = useState(true);
  const [showPassword2, setShowPassword2] = useState(true);
  const handleShow = () => {
    setShowPassword(!showPassword);
  };
  const handleShow2 = () => {
    setShowPassword2(!showPassword2);
  };

  const nextStep = async () => {
    const fieldsToValidate =
      step === 1
        ? ["username", "password", "confirmpassword"]
        : ["validateCode", "phoneNumber"];

    const isValid = await trigger(fieldsToValidate);
    if (isValid) setStep(step + 1);
   
  };

  const onSubmit = async (body) => {
    // localStorage.clear();
    
    try {
      const { status, data: response_users1 } = await apiPost(
        apiPath.registerUser,
        {
          username: body?.username,
          password: body?.password,
          uniqueId: Math.random() * 10000,
          phone_number: body?.mobile?.substring(
            inputRef?.current?.state.selectedCountry?.countryCode?.length,
            body?.mobile?.toString()?.length
          ),
          country_code:
            inputRef?.current?.state.selectedCountry?.countryCode,
          refreralCode: body?.referalCode || "",
          currency:currency=="en-IN"?"INR":"BDT"
        },
      );
      if (status === 200) {
        if (response_users1.success) {
          localStorage.setItem("token", response_users1?.results?.token);
          localStorage.setItem(
            "refresh_token",
            response_users1?.results?.refresh_token,
          );
          setUser(jwt_decode(response_users1?.results.token));
          navigate("/");
          window.location.reload();
        } else {
          toast.error(response_users1?.message);
        }
      } else {
        toast.error(response_users1?.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
    }
  };

  const { search } = useLocation();
  let code = search?.split("=")[1];
  let codeCondition = search?.split("=")?.includes("?referral_code")
    ? true
    : false;

  useEffect(() => {
    if (codeCondition) {
      setValue("referalCode", code);
    }
  }, [code, codeCondition]);

  const [currency, setCurrency] = useState(localStorage.getItem("language_dir") == "en-IN"?"en-IN":"bn-BD");
  const [isOpen, setIsOpen] = useState(false);

  const currencies = ["en-IN", "bn-BD"];

  return (
    <Layout>
      <div className="full-width">
        <div
          className={`col col-12 ${isMobile ? "px-2" : "px-5"}  register_panel`}
        >
          <div className="row hidden-md-and-up">
            <div className="mobile-header text-center col col-12">
              {t("RegisterNow")}
            </div>
          </div>
          <div
            className="row hidden-sm-and-down mt-2"
            style={{ margin: "unset" }}
          >
            <div className="login-header text-center py-0 col col-12">
              {t("CreateAccount")}
            </div>
            <div className="login-header-desc text-center pt-0 col col-12">
              {t("RegisterSubtitle")}
            </div>
          </div>

          <div
            className={`row justify-center ${isMobile ? "hidden-md-and-up" : "mt-2 hidden-sm-and-down mb-4"
              } `}
          >
            <div className="col col-12">
              <div className="v-window v-item-group theme--light ma-8">
                <div className="v-window__container">
                  <div className="v-window-item v-window-item--active">
                    <Form onSubmit={handleSubmit(onSubmit)} className="v-form">
                      <div className="row justify-center">
                        <div className="col-md-8 col-12">
                          {(isMobile ? step == 1 : true) && (
                            <div className="v-card__text ma-0 pa-0">
                              <div className={isMobile ? "mobile" : ""}>
                                <div className="row no-gutters justify-space-between">
                                  <div className="col col-10">
                                    <label
                                      className="input-field-label ma-0 text-capitalize d-block pb-1"
                                      style={{ float: "left" }}
                                    >
                                      {t("Username")}
                                      <span className="red--text ml-1">*</span>
                                    </label>
                                  </div>

                                  <div className="col col-12">
                                    <div
                                      className={`v-input input-field elevation-0 hide-details theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder ${!isEmpty(errors.username)
                                        ? "error--text v-input--has-state"
                                        : ""
                                        } `}
                                    >
                                      <div className="v-input__control">
                                        <div className="v-input__slot">
                                          <fieldset aria-hidden="true">
                                            <legend style={{ width: "0px" }}>
                                              <span className="notranslate">

                                              </span>
                                            </legend>
                                          </fieldset>
                                          <div className="v-text-field__slot">
                                            <input
                                              autoComplete="new-password"
                                              id="input-5797"
                                              placeholder={t("FillUpHere")}
                                              type="text"
                                              {...register("username", {
                                                required: t("Enter_Username"),

                                                minLength: {
                                                  value: 3,
                                                  message: t("Min3User"),
                                                },
                                                maxLength: {
                                                  value: 30,
                                                  message: t("Max30User"),
                                                },
                                                pattern: {
                                                  value: /^[a-zA-Z0-9]*$/,
                                                  message: t(
                                                    "Enter_Valid_Username",
                                                  ),
                                                },
                                              })}
                                            />
                                          </div>
                                        </div>
                                        {errors.username &&
                                          errors.username.message && (
                                            <div className="v-text-field__details">
                                              <div
                                                className="v-messages theme--light error--text"
                                                role="alert"
                                              >
                                                <div className="v-messages__wrapper">
                                                  <div className="v-messages__message">
                                                    {errors.username.message}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className={isMobile ? "mobile" : ""}>
                                <div className="row no-gutters justify-space-between">
                                  <div className="col col-10">
                                    <label
                                      className="input-field-label ma-0 text-capitalize d-block pb-1"
                                      style={{ float: "left" }}
                                    >
                                      {t("Password")}
                                      <span className="red--text ml-1">*</span>
                                    </label>
                                  </div>

                                  <div className="col col-12">
                                    <div
                                      className={`v-input input-field elevation-0 hide-details theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder ${!isEmpty(errors.password)
                                        ? "error--text v-input--has-state"
                                        : ""
                                        } `}
                                    >
                                      <div className="v-input__control">
                                        <div className="v-input__slot">
                                          <fieldset aria-hidden="true">
                                            <legend style={{ width: "0px" }}>
                                              <span className="notranslate">

                                              </span>
                                            </legend>
                                          </fieldset>
                                          <div className="v-text-field__slot">
                                            <input
                                              autoComplete="new-password"
                                              id="input-5803"
                                              type={
                                                !showPassword
                                                  ? "text"
                                                  : "password"
                                              }
                                              placeholder={t("Password")}
                                              {...register("password", {
                                                required: t("Enter_Password"),
                                                minLength: {
                                                  value: 6,
                                                  message: t("PasswordMin"),
                                                },
                                                maxLength: {
                                                  value: 20,
                                                  message: t("PasswordMax"),
                                                },
                                              })}
                                            />
                                          </div>
                                          <div
                                            onClick={() => handleShow()}
                                            className="v-input__append-inner"
                                          >
                                            <button
                                              type="button"
                                              className={`v-icon notranslate v-icon--link mdi ${showPassword
                                                ? "mdi-eye"
                                                : "mdi-eye-off"
                                                } theme--light`}
                                            />
                                          </div>
                                        </div>
                                        {errors.password &&
                                          errors.password.message && (
                                            <div className="v-text-field__details">
                                              <div
                                                className="v-messages theme--light error--text"
                                                role="alert"
                                              >
                                                <div className="v-messages__wrapper">
                                                  <div className="v-messages__message">
                                                    {errors.password.message}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className={isMobile ? "mobile" : ""}>
                                <div className="row no-gutters justify-space-between">
                                  <div className="col col-10">
                                    <label
                                      className="input-field-label ma-0 text-capitalize d-block pb-1"
                                      style={{ float: "left" }}
                                    >
                                      {t("Confirm_Password")}
                                      <span className="red--text ml-1">*</span>
                                    </label>
                                  </div>
                                  <div className="col col-2"></div>
                                  <div className="col col-12">
                                    <div
                                      className={`v-input input-field elevation-0 hide-details theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder ${!isEmpty(errors.confirmpassword)
                                        ? "error--text v-input--has-state"
                                        : ""
                                        } `}
                                    >
                                      <div className="v-input__control">
                                        <div className="v-input__slot">
                                          <fieldset aria-hidden="true">
                                            <legend style={{ width: "0px" }}>
                                              <span className="notranslate">

                                              </span>
                                            </legend>
                                          </fieldset>
                                          <div className="v-text-field__slot">
                                            <input
                                              autoComplete="new-password"
                                              id="input-5808"
                                              type={
                                                !showPassword2
                                                  ? "text"
                                                  : "password"
                                              }
                                              placeholder={t(
                                                "Confirm_Password",
                                              )}
                                              {...register("confirmpassword", {
                                                required: t("Enter_CPassword"),
                                                validate: (value) => {
                                                  if (
                                                    !isEmpty(watch("password"))
                                                  ) {
                                                    if (
                                                      value == watch("password")
                                                    ) {
                                                      return true;
                                                    } else {
                                                      return t("PasswordMatch");
                                                    }
                                                  }
                                                },
                                              })}
                                            />
                                          </div>
                                          <div
                                            onClick={() => handleShow2()}
                                            className="v-input__append-inner"
                                          >
                                            <button
                                              type="button"
                                              className={`v-icon notranslate v-icon--link mdi ${showPassword2
                                                ? "mdi-eye"
                                                : "mdi-eye-off"
                                                } theme--light`}
                                            />
                                          </div>
                                        </div>
                                        {errors.confirmpassword &&
                                          errors.confirmpassword.message && (
                                            <div className="v-text-field__details">
                                              <div
                                                className="v-messages theme--light error--text"
                                                role="alert"
                                              >
                                                <div className="v-messages__wrapper">
                                                  <div className="v-messages__message">
                                                    {
                                                      errors.confirmpassword
                                                        .message
                                                    }
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="pa-0 col-md-10 col-12">
                                <div className="v-card__text ma-0 pa-0">
                                  <label className="input-field-label ma-0 pb-1 text-capitalize d-block">
                                    {t("Currency")}
                                    <span className="red--text ml-1">*</span>
                                  </label>
                                  <div className="v-input v-input--is-label-active v-input--is-dirty v-input--dense theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-select">
                                    <div className="v-input__prepend-outer">
                                      <div className="v-input__icon v-input__icon--prepend">
                                        <span
                                          aria-hidden="true"
                                          className="v-icon notranslate theme--light"
                                        >

                                          {/* <IndiaIcon width={30} height={30} /> */}
                                          {
                                            currency=="bn-BD" ?
                                              <img src="../../assets/images/BDT.svg" style={{ width: `26px` }} /> :
                                              <img src="../../assets/images/INR.svg" style={{ width: `26px` }} />

                                          }
                                        </span>
                                      </div>
                                    </div>
                                    <div className="v-input__control">
                                      <div
                                        role="button"
                                        aria-haspopup="listbox"
                                        aria-expanded="false"
                                        aria-owns="list-5812"
                                        className="v-input__slot"
                                      >
                                        <fieldset aria-hidden="true">
                                          <legend style={{ width: "0px" }}>
                                            <span className="notranslate">

                                            </span>
                                          </legend>
                                        </fieldset>
                                        <div className="v-select" style={{width:`100%`}}>
                                        <div
                                          className="v-select__slot"
                                          onClick={() => setIsOpen(!isOpen)}
                                          style={{ cursor: "pointer" }}
                                        >
                                          <div className="v-select__selections">
                                            <div className="v-select__selection v-select__selection--comma">
                                              {currency=="en-IN"?"INR":"BDT"}
                                            </div>

                                            <input
                                              type="text"
                                              readOnly
                                              value={currency}
                                              aria-label="Select currency"
                                              style={{ display: "none" }}
                                            />
                                          </div>

                                          <div className="v-input__append-inner">
                                            <span>{isOpen ? "▲" : "▼"}</span>
                                          </div>
                                        </div>

                                        {isOpen && (
                                          <div className="currency-options">
                                            {currencies.map((item) => (
                                              <div
                                                key={item}
                                                className="currency-option"
                                                onClick={() => {
                                                  setCurrency(item);
                                                  setIsOpen(false);
                                                }}
                                              >
                                                {item=="en-IN"?"INR":"BDT"}
                                              </div>
                                            ))}
                                          </div>
                                        )}

                                        <input type="hidden" value={currency} readOnly />
                                      </div>
                                      <div className="v-menu" />
                                    </div>
                                    <div className="v-text-field__details">
                                      <div className="v-messages theme--light">
                                        <div className="v-messages__wrapper" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            </div>
                          )}
                        {(isMobile ? step == 1 : true) && (
                          <div className="row justify-center no-gutters">
                            <div className="col col-12">
                              <button
                                onClick={nextStep}
                                data-v-1dea3caa
                                type="button"
                                className="full-width font-weight-bold pa-2 dialog-button hidden-md-and-up v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default buttonPrimary theme-button theme--light subtitle-1 mobile-next-btn"
                              >
                                <span className="v-btn__content">
                                  {t("Next")}
                                </span>
                              </button>
                            </div>
                          </div>
                        )}{" "}
                        {(isMobile ? step == 2 : true) && (
                          <div
                            className={
                              !isMobile
                                ? "pa-0 hidden-sm-and-down col col-12"
                                : ""
                            }
                          >
                            <div className="v-card__text ma-0 pa-0">
                              <div className={isMobile ? "mobile" : ""}>
                                <div className="row no-gutters justify-space-between">
                                  <div no-gutters className="col col-10">
                                    <label
                                      className="input-field-label ma-0 text-capitalize d-block"
                                      style={{ float: "left" }}
                                    >
                                      {t("VerificationCode")}
                                      <span className="red--text ml-1">
                                        *
                                      </span>
                                    </label>
                                  </div>
                                  <div no-gutters className="col col-2" />
                                  <div no-gutters className="col col-8">
                                    <div
                                      className={`v-input input-field elevation-0 hide-details theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder ${!isEmpty(errors.validateCode)
                                        ? "error--text v-input--has-state"
                                        : ""
                                        } `}
                                    >
                                      <div className="v-input__control">
                                        <div className="v-input__slot">
                                          <fieldset aria-hidden="true">
                                            <legend style={{ width: "0px" }}>
                                              <span className="notranslate">

                                              </span>
                                            </legend>
                                          </fieldset>
                                          <div className="v-text-field__slot">
                                            <input
                                              autoComplete="new-password"
                                              autofocus="autofocus"
                                              id="input-5825"
                                              type="text"
                                              {...register("validateCode", {
                                                required:
                                                  t("Enter_Vadlidation"),
                                                validate: {
                                                  validate: (value) =>
                                                    parseInt(value) ===
                                                    parseInt(captcha) ||
                                                    t("Invalidvalidatecode"),
                                                },
                                              })}
                                            />
                                          </div>
                                        </div>
                                        {errors.validateCode &&
                                          errors.validateCode.message && (
                                            <div className="v-text-field__details">
                                              <div
                                                className="v-messages theme--light error--text"
                                                role="alert"
                                              >
                                                <div className="v-messages__wrapper">
                                                  <div className="v-messages__message">
                                                    {
                                                      errors.validateCode
                                                        .message
                                                    }
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                      </div>
                                    </div>
                                  </div>
                                  <CanvasCaptcha
                                    captcha={captcha}
                                    setCaptcha={setCaptcha}
                                  />
                                </div>
                              </div>
                              <label className="input-field-label ma-0 text-capitalize d-block pb-1">
                                {t("PhoneNumber")}
                                <span className="red--text ml-1">*</span>
                              </label>
                              <div className="row no-gutters">
                                {/* <div className="col col-5">
                                    <div className={isMobile ? "mobile" : ""}>
                                      <div className="row no-gutters justify-space-between">
                                        <div className="col col-10"></div>
                                        <div className="col col-2"></div>
                                        <div className="col col-12">
                                          <div className="v-input input-field elevation-0 hide-details v-input--is-label-active v-input--is-dirty v-input--is-disabled v-input--is-readonly theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder mr-2 reg-mobile-prefix">
                                            <div className="v-input__control">
                                              <div className="v-input__slot">
                                                <fieldset aria-hidden="true">
                                                  <legend
                                                    style={{ width: "0px" }}
                                                  >
                                                    <span className="notranslate">
                                                      ​
                                                    </span>
                                                  </legend>
                                                </fieldset>
                                                <div className="v-text-field__slot">
                                                  <input
                                                    disabled
                                                    id="input-5831"
                                                    readOnly="readonly"
                                                    type="text"
                                                    value={"+880"}
                                                  />
                                                </div>
                                              </div>
                                              <div className="v-text-field__details">
                                                <div className="v-messages theme--light">
                                                  <div className="v-messages__wrapper" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div> */}
                                <div className="col col-12">
                                  <div className={isMobile ? "mobile" : ""}>
                                    <div className="row no-gutters justify-space-between">
                                      <div className="col col-10"></div>
                                      <div className="col col-2"></div>
                                      <div className="col col-12">
                                        <div
                                          className={`v-input input-field elevation-0 hide-details theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder ${!isEmpty(errors.phoneNumber)
                                            ? "error--text v-input--has-state"
                                            : ""
                                            } `}
                                        >
                                          <div className="v-input__control">
                                            <div className="v-input__slot">
                                              <fieldset aria-hidden="true">
                                                <legend
                                                  style={{ width: "0px" }}
                                                >
                                                  <span className="notranslate">

                                                  </span>
                                                </legend>
                                              </fieldset>
                                              <div className="v-text-field__slot">
                                                <Controller
                                                  className="form-group d-flex"
                                                  control={control}
                                                  name="mobile"
                                                  rules={{
                                                    required: "Please enter mobile number.",
                                                    validate: (value) => {
                                                      let inputValue = value
                                                        ?.toString()
                                                        ?.slice(
                                                          inputRef?.current?.state?.selectedCountry?.countryCode
                                                            ?.length,
                                                          value?.length
                                                        );
                                                      if (inputValue?.length < 10) {
                                                        return "Mobile number must contain 10 digit";
                                                      } else if (inputValue?.length > 12) {
                                                        return "Mobile number should not exceed 12 digit";
                                                      } else {
                                                        return true;
                                                      }
                                                    },
                                                  }}
                                                  render={({ field: { ref, ...field } }) => (
                                                    <>
                                                      <PhoneInput
                                                        {...field}
                                                        // isValid={(value, country) => {
                                                        //   if (value.match(/12345/)) {
                                                        //     return 'Invalid value: '+value+', '+country.name;
                                                        //   } else if (value.match(/1234/)) {
                                                        //     return false;
                                                        //   } else {
                                                        //     return true;
                                                        //   }
                                                        // }}
                                                        inputExtraProps={{
                                                          ref,
                                                          required: true,
                                                          autoFocus: true,
                                                        }}
                                                        ref={inputRef}
                                                        inputStyle={{
                                                          width: "100%",
                                                          height: "38px",
                                                        }}
                                                        country={currency=="en-IN"?"in":"bd"}
                                                        enableSearch
                                                        countryCodeEditable={false}
                                                      />
                                                    </>
                                                  )}
                                                />
                                              </div>
                                            </div>
                                            {errors.phoneNumber &&
                                              errors.phoneNumber.message && (
                                                <div className="v-text-field__details">
                                                  <div
                                                    className="v-messages theme--light error--text"
                                                    role="alert"
                                                  >
                                                    <div className="v-messages__wrapper">
                                                      <div className="v-messages__message">
                                                        {
                                                          errors.phoneNumber
                                                            .message
                                                        }
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="row no-gutters">
                                <div className="col col-12">
                                  <div className={isMobile ? "mobile" : ""}>
                                    <div className="row no-gutters justify-space-between">
                                      <div className="col col-10">
                                        <label
                                          className="input-field-label ma-0 text-capitalize d-block pb-1"
                                          style={{ float: "left" }}
                                        >
                                          {t("ReferralCode")}
                                        </label>
                                      </div>
                                      <div className="col col-2"></div>
                                      <div className="col col-12">
                                        <div className="v-input input-field elevation-0 hide-details theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                                          <div className="v-input__control">
                                            <div className="v-input__slot">
                                              <fieldset aria-hidden="true">
                                                <legend
                                                  style={{ width: "0px" }}
                                                >
                                                  <span className="notranslate">

                                                  </span>
                                                </legend>
                                              </fieldset>
                                              <div className="v-text-field__slot">
                                                <input
                                                  autoComplete="new-password"
                                                  id="input-5839"
                                                  placeholder={t("Optional")}
                                                  type="text"
                                                  {...register("referalCode")}
                                                />
                                              </div>
                                            </div>
                                            <div className="v-text-field__details">
                                              <div className="v-messages theme--light">
                                                <div className="v-messages__wrapper" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="row no-gutters">
                                <div className="col col-12">
                                  <div className="v-input mt-0 pt-0 theme--light v-input--selection-controls v-input--checkbox">
                                    <div className="v-input__control">
                                      <div className="v-input__slot">
                                        <div className="v-input--selection-controls__input"
                                        >
                                          <i
                                            aria-hidden="true"
                                            className={`v-icon notranslate mdi ${checked
                                              ? "mdi-checkbox-marked theme--light primary--text"
                                              : "mdi-checkbox-blank-outline theme--light primary--text"
                                              }`}
                                          />

                                          <input
                                            id="legal-age"
                                            type="checkbox"
                                            checked={checked}
                                            onChange={(e) => setChecked(e.target.checked)}
                                          />

                                          <div className={`v-input--selection-controls__ripple ${checked
                                            ? "primary--text"
                                            : ""
                                            }`} />
                                        </div>

                                        <label
                                          htmlFor="legal-age"
                                          className="v-label theme--light"
                                          style={{
                                            left: "0px",
                                            right: "auto",
                                            position: "relative",
                                          }}
                                        >
                                          <p className="caption pt-2 mb-0">
                                            <span>{t("LegalAgeAgree")} </span>
                                            <span
                                              className="text-decoration-underline font-weight-bold"
                                              style={{ cursor: "pointer" }}
                                            >
                                              {t("TermsAndConditions")}
                                            </span>
                                          </p>
                                        </label>
                                      </div>
                                      <div className="v-messages theme--light">
                                        <div className="v-messages__wrapper" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="row no-gutters">
                                <div className="col col-12">
                                  <button
                                    data-v-1dea3caa
                                    type="submit"
                                    className="full-width font-weight-bold pa-2 dialog-button v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default buttonPrimary theme-button theme--light subtitle-1 mobile-next-btn"
                                  >
                                    <span className="v-btn__content">
                                      {t("CompleteRegistration")}
                                    </span>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="row justify-center mt-2 hidden-sm-and-down mb-4">
            <div className="login-form-bg pa-0 col-md-10 col-12">
              <div className="ma-8">
                <FromPage />
              </div>
            </div>
          </div> */}
    </div>
      </div >
    </Layout >
  );
};

export default Register;
